import { RD_BASE } from './config';

/**
 * 查询合规事件新闻流（近 90 天）
 * 用 Brave Search 实时抓取，覆盖静态名单查不到的事件
 * @param {string} projectName
 * @returns {Promise<{events:[], highCount, mediumCount, lowCount}|null>}
 */
export async function fetchComplianceEvents(projectName) {
  if (!projectName || projectName.length < 2) return null;
  try {
    const res = await fetch(
      `${RD_BASE}/api/compliance/events?name=${encodeURIComponent(projectName)}`,
      { signal: AbortSignal.timeout(15000) }
    );
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

/**
 * 查询四大合规数据库：OFAC 制裁 / SEC 执法 / FCA 注册 / FinCEN MSB
 * @param {string} projectName   - 项目名
 * @param {string} tokenSymbol   - 代币符号（可选）
 * @param {string[]} founderNames - 创始人姓名列表（可选，取前 3 个）
 * @returns {Promise<object|null>}
 */
export async function fetchComplianceCheck(projectName, tokenSymbol = '', founderNames = []) {
  if (!projectName) return null;
  try {
    const params = new URLSearchParams({
      name: projectName,
      token: tokenSymbol || '',
      founders: founderNames.slice(0, 3).join(','),
    });
    const res = await fetch(`${RD_BASE}/api/compliance?${params}`, {
      signal: AbortSignal.timeout(20000),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
